(() => {
  if (window.__MQAMIS_NEWSLETTER20__) return;
  window.__MQAMIS_NEWSLETTER20__ = true;

  const KEY = 'mqamis_newsletter20_v1';
  const now = Date.now();

  function readState() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (_) { return {}; }
  }
  function writeState(next) {
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (_) {}
  }

  const state = readState();
  if (state.subscribed) return;
  if (state.dismissedAt && now - state.dismissedAt < 2 * 24 * 60 * 60 * 1000) return;

  function mount() {
    if (!document.body || document.getElementById('mqamis-newsletter20-overlay')) return;

    const style = document.createElement('style');
    style.id = 'mqamis-newsletter20-style';
    style.textContent = `
      #mqamis-newsletter20-overlay{position:fixed;inset:0;background:rgba(0,0,0,.62);display:flex;align-items:center;justify-content:center;padding:20px;z-index:2147483000;opacity:0;transition:opacity .25s ease}
      #mqamis-newsletter20-overlay.mq-open{opacity:1}
      #mqamis-newsletter20-modal{position:relative;width:min(100%,470px);background:#fff;color:#111;border-radius:22px;padding:38px 34px 32px;box-shadow:0 24px 80px rgba(0,0,0,.28);font-family:inherit;text-align:center;transform:translateY(12px) scale(.985);transition:transform .25s ease}
      #mqamis-newsletter20-overlay.mq-open #mqamis-newsletter20-modal{transform:translateY(0) scale(1)}
      #mqamis-newsletter20-close{position:absolute;right:14px;top:12px;border:0;background:transparent;color:#111;font-size:28px;line-height:1;cursor:pointer;padding:8px}
      .mqamis-n20-brand{font-size:12px;letter-spacing:.28em;font-weight:700;margin-bottom:14px}
      .mqamis-n20-kicker{font-size:13px;text-transform:uppercase;letter-spacing:.12em;color:#6b6b6b;margin:0 0 8px}
      .mqamis-n20-title{font-size:34px;line-height:1.08;margin:0 0 14px;font-weight:750;letter-spacing:-.02em}
      .mqamis-n20-copy{font-size:15px;line-height:1.55;color:#454545;margin:0 auto 18px;max-width:390px}
      .mqamis-n20-existing{font-size:14px;line-height:1.45;font-weight:600;margin:0 0 20px}
      #mqamis-newsletter20-form{display:grid;gap:11px}
      #mqamis-newsletter20-email{width:100%;box-sizing:border-box;border:1px solid #cfcfcf;border-radius:11px;padding:15px 14px;font:inherit;font-size:15px;outline:none;background:#fff;color:#111}
      #mqamis-newsletter20-email:focus{border-color:#111;box-shadow:0 0 0 1px #111}
      #mqamis-newsletter20-submit{width:100%;border:0;border-radius:11px;padding:15px 16px;background:#111;color:#fff;font:inherit;font-size:14px;font-weight:750;letter-spacing:.06em;cursor:pointer}
      #mqamis-newsletter20-submit[disabled]{opacity:.62;cursor:wait}
      .mqamis-n20-legal{font-size:11px;line-height:1.45;color:#767676;margin:2px 4px 0}
      .mqamis-n20-status{font-size:13px;line-height:1.4;margin-top:2px;min-height:18px}
      .mqamis-n20-success{padding:18px 4px 8px}
      .mqamis-n20-success h3{font-size:28px;line-height:1.15;margin:0 0 10px}
      .mqamis-n20-success p{font-size:15px;line-height:1.55;color:#454545;margin:0}
      @media(max-width:520px){
        #mqamis-newsletter20-overlay{align-items:flex-end;padding:12px}
        #mqamis-newsletter20-modal{border-radius:20px;padding:34px 20px 24px}
        .mqamis-n20-title{font-size:29px}
      }
    `;
    document.head.appendChild(style);

    const overlay = document.createElement('div');
    overlay.id = 'mqamis-newsletter20-overlay';
    overlay.innerHTML = `
      <div id="mqamis-newsletter20-modal" role="dialog" aria-modal="true" aria-labelledby="mqamis-newsletter20-title">
        <button id="mqamis-newsletter20-close" type="button" aria-label="Fermer">×</button>
        <div class="mqamis-n20-brand">MQAMIS</div>
        <p class="mqamis-n20-kicker">Offre newsletter</p>
        <h2 class="mqamis-n20-title" id="mqamis-newsletter20-title">-20 % sur votre prochaine commande</h2>
        <p class="mqamis-n20-copy">Inscrivez-vous à la newsletter Mqamis pour profiter de votre avantage de -20 % sur votre prochaine commande.</p>
        <p class="mqamis-n20-existing">Déjà client ? L’offre est aussi valable pour vous.</p>
        <form id="mqamis-newsletter20-form">
          <input id="mqamis-newsletter20-email" name="email" type="email" autocomplete="email" inputmode="email" placeholder="Votre adresse email" aria-label="Votre adresse email" required>
          <button id="mqamis-newsletter20-submit" type="submit">RECEVOIR MES -20 %</button>
          <div class="mqamis-n20-status" id="mqamis-newsletter20-status" aria-live="polite"></div>
          <p class="mqamis-n20-legal">En vous inscrivant, vous acceptez de recevoir les emails marketing de Mqamis. Vous pouvez vous désinscrire à tout moment.</p>
        </form>
      </div>
    `;

    document.body.appendChild(overlay);

    const close = () => {
      writeState({ ...readState(), dismissedAt: Date.now() });
      overlay.classList.remove('mq-open');
      setTimeout(() => overlay.remove(), 250);
    };

    overlay.querySelector('#mqamis-newsletter20-close').addEventListener('click', close);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape' && document.body.contains(overlay)) close();
      if (!document.body.contains(overlay)) document.removeEventListener('keydown', esc);
    });

    const form = overlay.querySelector('#mqamis-newsletter20-form');
    const email = overlay.querySelector('#mqamis-newsletter20-email');
    const submit = overlay.querySelector('#mqamis-newsletter20-submit');
    const status = overlay.querySelector('#mqamis-newsletter20-status');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const value = email.value.trim();
      if (!value || !email.checkValidity()) {
        email.reportValidity();
        return;
      }

      submit.disabled = true;
      submit.textContent = 'INSCRIPTION…';
      status.textContent = '';
      if (form.dataset.submitting === 'true') return;
      form.dataset.submitting = 'true';

      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      const endpoint = root.replace(/\/?$/, '/') + 'contact';
      const data = new FormData();
      data.append('form_type', 'customer');
      data.append('utf8', '✓');
      data.append('contact[tags]', 'newsletter,newsletter-popup-20');
      data.append('contact[email]', value);
      data.append('return_to', root.replace(/\/?$/, '/') + '?customer_posted=true');

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: { 'Accept': 'text/html' }
        });

        if (!response.ok) throw new Error('HTTP ' + response.status);
        // Shopify redirects here only after accepting the newsletter form.
        // A challenge or validation page must never be treated as an inscription.
        const resultUrl = new URL(response.url, window.location.origin);
        if (resultUrl.pathname.includes('/challenge') || resultUrl.searchParams.get('customer_posted') !== 'true') {
          throw new Error('Subscription was not confirmed by Shopify');
        }

        writeState({ subscribed: true, subscribedAt: Date.now() });
        const modal = overlay.querySelector('#mqamis-newsletter20-modal');
        modal.innerHTML = `
          <button id="mqamis-newsletter20-close-success" type="button" aria-label="Fermer" style="position:absolute;right:14px;top:12px;border:0;background:transparent;color:#111;font-size:28px;line-height:1;cursor:pointer;padding:8px">×</button>
          <div class="mqamis-n20-brand">MQAMIS</div>
          <div class="mqamis-n20-success">
            <h3 id="mqamis-newsletter20-title" tabindex="-1">Votre code est prêt</h3>
            <p>Merci pour votre inscription à la newsletter Mqamis.</p>
            <p style="margin:20px 0;padding:16px;border:1px dashed #111;border-radius:11px;font-size:27px;font-weight:750;letter-spacing:.12em;color:#111;user-select:all">MQAMIS20</p>
            <p>-20 % sur votre prochaine commande.<br>Une utilisation par client.</p>
          </div>
        `;
        modal.querySelector('#mqamis-newsletter20-title').focus({ preventScroll: true });
        modal.querySelector('#mqamis-newsletter20-close-success').addEventListener('click', () => {
          overlay.classList.remove('mq-open');
          setTimeout(() => overlay.remove(), 250);
        });
      } catch (err) {
        status.textContent = "Une erreur est survenue. Réessayez dans quelques instants.";
        form.dataset.submitting = 'false';
        submit.disabled = false;
        submit.textContent = 'RECEVOIR MES -20 %';
      }
    });

    requestAnimationFrame(() => {
      overlay.classList.add('mq-open');
    });
  }

  const start = () => {
    let delayElapsed = false;
    let visitorEngaged = false;
    let mounted = false;
    const events = ['pointerdown', 'keydown', 'scroll'];

    const cleanup = () => {
      events.forEach((eventName) => document.removeEventListener(eventName, onEngage));
    };
    const maybeMount = () => {
      if (mounted || !delayElapsed || !visitorEngaged) return;
      mounted = true;
      cleanup();
      mount();
    };
    const onEngage = () => {
      visitorEngaged = true;
      maybeMount();
    };

    events.forEach((eventName) => document.addEventListener(eventName, onEngage, { passive: true }));
    setTimeout(() => {
      delayElapsed = true;
      maybeMount();
    }, 3000);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
